function Costs() {
    this.$el = $('.partner-landing-cost');

    if (this.$el.length) {
        this.setupDefaults();
        this.init();
    }
};

Costs.prototype.setupDefaults = function () {
    this.width = 0;

    this.dom = {
        $stats: this.$el.find('.partner-landing-cost__item-statistic')
    }
};

Costs.prototype.init = function () {
    var _this = this;

    this.dom.$stats.each(function(i, element) {
        if($(element).width() > _this.width) {
            _this.width = $(element).width();
        }
    });
    
    this.dom.$stats.width(this.width);
};


(function ($) {
    new Costs();
})(jQuery);